import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const availableConstructionPhases = createAsyncThunk('availableConstructionPhases', async ({ project_id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `construction-project/available-phases/${project_id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const availableConstructionPhasesSlice = createSlice({
    name: 'availableConstructionPhases',
    initialState: {
        data: null,
        projectId: null,
    },
    reducers: {
        clearAvailableConstructionPhases: (state) => {
            state.data = null
            state.projectId = null
        },
    },
    extraReducers: (builder) => {
        builder.addCase(availableConstructionPhases.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data?.data ?? null
                state.projectId = action.meta.arg?.project_id ?? null
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
                state.data = null
                state.projectId = null
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
                state.data = null
                state.projectId = null
            } else {
                state.data = null
                state.projectId = null
            }

        });
        builder.addCase(availableConstructionPhases.rejected, (state) => {
            state.data = null
            state.projectId = null
        })
    }
})

export const { clearAvailableConstructionPhases } = availableConstructionPhasesSlice.actions;
export default availableConstructionPhasesSlice.reducer;
